import React, { Component } from 'react';
import './dataTable/css/table-twbs.css';
import _ from 'underscore';

let DataTable = require('./dataTable').DataTable;
let arr = [];

class genericList extends Component {
  constructor(props) {
    super(props);

    if (this.props.list.location.pathname === '/associate-roster') {
      this.state = {
        temp: [],
        object: [],
        columns: [
          { prop: 'associate', title: 'Associate' },
          { prop: 'title', title: 'Position' },
          { prop: 'department', title: 'Team' },
          { prop: 'phone', title: 'Phone' },
          { prop: 'email', title: 'Email' },
        ],
        location: this.props.list.location.pathname,
        dataLoaded: false,
        pageIndex: null,
      };
    } else {
      this.state = {
        temp: [],
        object: [],
        columns: [
          { prop: 'title', title: 'Name' },
          { prop: 'department', title: 'Department' },
          { prop: 'uploadDate', title: 'Date Modified' },
        ],
        location: this.props.list.location.pathname,
        dataLoaded: false,
        pageIndex: null,
      };
    }

    this.tempFiles = this.props.list.listPageQuery.genericPageListingOfFiles;

    this.componentDidMount = this.componentDidMount.bind(this);
    this.buildRowOptions = this.buildRowOptions.bind(this);
    this.Map = this.Map.bind(this);
    this.checkBox = this.checkBox.bind(this);
    this.getDocsForPage = this.getDocsForPage.bind(this);
    this.getCurrentPageIndex = this.getCurrentPageIndex.bind(this);
  }

  getCurrentPageIndex(location) {
    let index = null;
    for (let i = 0; i < this.tempFiles.length; i++) {
      if ('/' + this.tempFiles[i].route === location) {
        index = i;
        break;
      }
    }
    return index;
  }

  getDocsForPage(page) {
    const experience = window.localStorage.getItem('experience') || 'internal';

    const seasonal =
      page && Array.isArray(page.seasonalFilesAndDocuments) ? page.seasonalFilesAndDocuments : [];
    const internal =
      page && Array.isArray(page.filesAndDocuments) ? page.filesAndDocuments : [];

    if (experience === 'seasonal' && seasonal.length > 0) return seasonal;
    return internal;
  }

  // NEW: derive departments dynamically from the currently loaded dataset (this.state.temp)
  getDepartmentsFromDocs(docs) {
    if (!Array.isArray(docs)) return [];

    const uniq = {};
    for (let i = 0; i < docs.length; i++) {
      const d = docs[i] && docs[i].department;
      if (typeof d === 'string') {
        const trimmed = d.trim();
        if (trimmed) uniq[trimmed] = true;
      }
    }

    return Object.keys(uniq).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  // helper to make checkbox ids safe/stable
  makeDeptId(dept) {
    return String(dept)
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]/g, '');
  }

  Map(depts) {
    let location = depts.props.list.location.pathname;

    // Keep associate-roster behavior unchanged
    if (location === '/associate-roster') return <fieldset className="form-group" />;

    // Use the full unfiltered dataset for the checkbox list
    const departments = this.getDepartmentsFromDocs(this.state.temp);
    let self = this;

    return (
      <fieldset className="form-group">
        {departments.map(function (dept, idx) {
          const id = self.makeDeptId(dept);
          return (
            <label key={id || idx} className="checkbox black" htmlFor={id}>
              <input
                value={dept}
                type="checkbox"
                id={id}
                onClick={() => self.checkBox(self.state.object, dept)}
              />
              {dept}
            </label>
          );
        })}
      </fieldset>
    );
  }

  checkBox(obj, dept) {
    let temp = this.state.temp;

    if (!arr.includes(dept)) {
      arr.push(dept);
      obj = _.where(obj, { department: dept });
      this.setState({ object: obj });
    } else {
      arr = _.filter(arr, function (value) {
        return value !== dept;
      });

      if (arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          temp = _.filter(temp, { department: arr[i] });
        }
        this.setState({ object: temp });
      } else {
        this.setState({ object: this.state.temp });
      }
    }
  }

  buildRowOptions(row) {
    let temp = row;
    if (row.associate == null) {
      return {
        onClick: function () {
          window.location = temp.fileUpload.url;
        },
      };
    }
  }

  componentDidMount() {
    let location = this.state.location;

    // reset checkbox selections when changing pages
    arr = [];

    if (location === '/associate-roster') {
      fetch('/employee', {
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      })
        .then((response) => response.json())
        .then((associate) => {
          associate.associates.sort(function (a, b) {
            if (a.associate < b.associate) return -1;
            if (a.associate > b.associate) return 1;
            return 0;
          });
          this.setState({ object: associate.associates });
          this.setState({ temp: associate.associates });
          this.setState({ dataLoaded: true });
        });
    } else {
      let index = this.getCurrentPageIndex(location);
      if (index == null) {
        this.setState({ dataLoaded: true, object: [], temp: [], pageIndex: null });
        return;
      }

      let page = this.tempFiles[index];
      let docs = this.getDocsForPage(page);

      this.setState({ object: docs });
      this.setState({ temp: docs });
      this.setState({ dataLoaded: true });
      this.setState({ pageIndex: index });
    }
  }

  render() {
    const depts = this.props.list.listPageQuery;
    let dataLoaded = this.state.dataLoaded;

    if (!dataLoaded) return <div> Loading... </div>;

    let key = this.props.list.location.pathname === '/associate-roster' ? 'associate' : 'title';

    let headerText = '';
    if (key === 'associate') {
      headerText = 'Associate Roster';
    } else {
      const idx =
        this.state.pageIndex != null
          ? this.state.pageIndex
          : this.getCurrentPageIndex(this.props.list.location.pathname);
      const page = idx != null ? depts.genericPageListingOfFiles[idx] : null;
      headerText = page && page.filesAndDocumentsHeader ? page.filesAndDocumentsHeader : '';
    }

    return (
      <section className="section">
        <header className="section-header row">
          <div className="col">
            <h2 className="section-title">{headerText}</h2>
          </div>
        </header>

        <div className="section-content row cubs-spotlight">
          {key !== 'associate' && (
            <div className="col md-3 spotlight">
              <form action="#" method="get" id="deptForm" noValidate="novalidate">
                {this.Map(this)}
              </form>
            </div>
          )}

          <div className="col md-9 spotlight black">
            <DataTable
              className="black"
              keys={key}
              columns={this.state.columns}
              initialData={this.state.object}
              buildRowOptions={this.buildRowOptions}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default genericList;